import {ISearchPage,ICmSearchPageFields} from "../../../types/FmsTypes";
//操作类型
export enum ExecType {
    I = "I",
    U = "U",
    D = "D",
    S = "S",

}
//审核状态
export enum ExecStatus {
    "待审核" = 0,
    "执行中" = 1,
    "执行成功" = 2,
    "执行异常" = 9,
}

//搜索参数
export interface IJournalParams {
    branch?:string,
    catalog?:string,
    execType?:string,
    execStatus?:string,
    sourceApp?:string
}
//列表参数
export interface IJournalDetail {
    code?: string,
    catalog?: string,
    branch?: string,
    execType?: string,
    execData?: string,
    execStatus?: number,
    reviewer?: string,
    reviewTime: null|string,
    sourceApp?: string,
    sourceAuthKey?: null|string,
    key?: string
}
//审核参数
export interface ReviewTypes {
    ids:string[]
}
export interface IJournalSearch extends IJournalParams,ICmSearchPageFields{

}